
  module.exports =
  {
    search: require('./WiFiGuarantee/search'),
    orders: require('./WiFiGuarantee/orders'),
  }